import React from 'react';
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Neralen - Ζαχαροπλαστική Τέχνη</title>
        <meta name="description" content="Neralen - Ανακαλύψτε τον κόσμο της ζαχαροπλαστικής τέχνης με αυθεντικές συνταγές και επαγγελματικές συμβουλές" />
      </Helmet>

      <div className="policy-container">
      <div className="policy-content">
        <h1>Πολιτική Απορρήτου</h1>
        <p className="last-updated">Τελευταία ενημέρωση: {new Date().toLocaleDateString('el-GR')}</p>

        <section>
          <h2>1. Εισαγωγή</h2>
          <p>
            Καλώς ήρθατε στο Neralen. Σεβόμαστε την ιδιωτικότητά σας και δεσμευόμαστε να προστατεύουμε 
            τα προσωπικά σας δεδομένα. Αυτή η πολιτική απορρήτου θα σας ενημερώσει για τον τρόπο με τον 
            οποίο φροντίζουμε τα προσωπικά σας δεδομένα όταν επισκέπτεστε τον ιστότοπό μας και θα σας 
            ενημερώσει για τα δικαιώματά σας στο απόρρητο και πώς σας προστατεύει ο νόμος.
          </p>
        </section>

        <section>
          <h2>2. Δεδομένα που Συλλέγουμε</h2>
          <p>Μπορεί να συλλέξουμε, να χρησιμοποιήσουμε, να αποθηκεύσουμε και να μεταφέρουμε διαφορετικά είδη προσωπικών δεδομένων σχετικά με εσάς:</p>
          <ul>
            <li><strong>Δεδομένα Ταυτότητας:</strong> όνομα, επώνυμο, όνομα χρήστη</li>
            <li><strong>Δεδομένα Επικοινωνίας:</strong> διεύθυνση email, αριθμός τηλεφώνου, ταχυδρομική διεύθυνση</li>
            <li><strong>Τεχνικά Δεδομένα:</strong> διεύθυνση IP, τύπος και έκδοση προγράμματος περιήγησης, ρυθμίσεις ζώνης ώρας</li>
            <li><strong>Δεδομένα Χρήσης:</strong> πληροφορίες σχετικά με τον τρόπο που χρησιμοποιείτε τον ιστότοπό μας</li>
            <li><strong>Δεδομένα Μάρκετινγκ:</strong> προτιμήσεις σας για λήψη μηνυμάτων μάρκετινγκ</li>
          </ul>
        </section>

        <section>
          <h2>3. Πώς Χρησιμοποιούμε τα Δεδομένα σας</h2>
          <p>Χρησιμοποιούμε τα δεδομένα σας για τους ακόλουθους σκοπούς:</p>
          <ul>
            <li>Να σας παρέχουμε πρόσβαση στο περιεχόμενο και τις υπηρεσίες μας</li>
            <li>Να διαχειριζόμαστε τη σχέση μας μαζί σας, συμπεριλαμβανομένων ειδοποιήσεων σχετικά με αλλαγές</li>
            <li>Να σας ζητήσουμε να αφήσετε μια κριτική ή να συμμετάσχετε σε μια έρευνα</li>
            <li>Να βελτιώσουμε τον ιστότοπο, τα προϊόντα/υπηρεσίες και το μάρκετινγκ</li>
            <li>Να σας προτείνουμε αγαθά ή υπηρεσίες που μπορεί να σας ενδιαφέρουν</li>
            <li>Να μετρήσουμε ή να κατανοήσουμε την αποτελεσματικότητα της διαφήμισης</li>
            <li>Να χρησιμοποιήσουμε ανάλυση δεδομένων για τη βελτίωση της εμπειρίας χρήστη</li>
          </ul>
        </section>

        <section>
          <h2>4. Cookies και Τεχνολογίες Παρακολούθησης</h2>
          <p>
            Χρησιμοποιούμε cookies και παρόμοιες τεχνολογίες παρακολούθησης για να παρακολουθούμε τη 
            δραστηριότητα στον ιστότοπό μας και να διατηρούμε ορισμένες πληροφορίες. Τα cookies είναι 
            αρχεία με μικρή ποσότητα δεδομένων που μπορεί να περιλαμβάνουν ένα ανώνυμο μοναδικό αναγνωριστικό.
          </p>
          <p>Χρησιμοποιούμε τα ακόλουθα είδη cookies:</p>
          <ul>
            <li><strong>Απαραίτητα Cookies:</strong> Είναι απαραίτητα για τη λειτουργία του ιστότοπου</li>
            <li><strong>Cookies Απόδοσης:</strong> Μας βοηθούν να κατανοήσουμε πώς οι επισκέπτες αλληλεπιδρούν με τον ιστότοπο</li>
            <li><strong>Cookies Λειτουργικότητας:</strong> Μας επιτρέπουν να απομνημονεύουμε τις επιλογές σας</li>
            <li><strong>Cookies Διαφήμισης:</strong> Χρησιμοποιούνται για την παροχή στοχευμένων διαφημίσεων</li>
          </ul>
        </section>

        <section>
          <h2>5. Κοινοποίηση Δεδομένων</h2>
          <p>Μπορεί να κοινοποιήσουμε τα προσωπικά σας δεδομένα στα ακόλουθα μέρη:</p>
          <ul>
            <li>Πάροχοι υπηρεσιών που παρέχουν υπηρεσίες IT και διαχείρισης συστημάτων</li>
            <li>Επαγγελματίες σύμβουλοι συμπεριλαμβανομένων δικηγόρων, τραπεζιτών, ελεγκτών και ασφαλιστών</li>
            <li>Φορολογικές αρχές, ρυθμιστικές και άλλες αρχές</li>
            <li>Τρίτοι στους οποίους μπορεί να επιλέξουμε να πουλήσουμε, να μεταφέρουμε ή να συγχωνεύσουμε μέρη της επιχείρησής μας</li>
          </ul>
        </section>

        <section>
          <h2>6. Ασφάλεια Δεδομένων</h2>
          <p>
            Έχουμε θέσει σε ισχύ κατάλληλα μέτρα ασφαλείας για να αποτρέψουμε την τυχαία απώλεια, 
            χρήση ή πρόσβαση των προσωπικών σας δεδομένων με μη εξουσιοδοτημένο τρόπο, την αλλοίωση 
            ή την αποκάλυψή τους. Επιπλέον, περιορίζουμε την πρόσβαση στα προσωπικά σας δεδομένα σε 
            εκείνους τους υπαλλήλους, αντιπροσώπους, εργολάβους και άλλα τρίτα μέρη που έχουν επιχειρηματική ανάγκη.
          </p>
        </section>

        <section>
          <h2>7. Διατήρηση Δεδομένων</h2>
          <p>
            Θα διατηρήσουμε τα προσωπικά σας δεδομένα μόνο για όσο χρονικό διάστημα είναι απαραίτητο 
            για την εκπλήρωση των σκοπών για τους οποίους τα συλλέγουμε, συμπεριλαμβανομένων των σκοπών 
            ικανοποίησης νομικών, λογιστικών ή αναφορών απαιτήσεων.
          </p>
        </section>

        <section>
          <h2>8. Τα Νομικά σας Δικαιώματα</h2>
          <p>Σύμφωνα με τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR), έχετε τα ακόλουθα δικαιώματα:</p>
          <ul>
            <li><strong>Δικαίωμα πρόσβασης:</strong> Να λάβετε αντίγραφο των προσωπικών σας δεδομένων</li>
            <li><strong>Δικαίωμα διόρθωσης:</strong> Να ζητήσετε διόρθωση ανακριβών δεδομένων</li>
            <li><strong>Δικαίωμα διαγραφής:</strong> Να ζητήσετε τη διαγραφή των προσωπικών σας δεδομένων</li>
            <li><strong>Δικαίωμα περιορισμού:</strong> Να ζητήσετε περιορισμό της επεξεργασίας</li>
            <li><strong>Δικαίωμα φορητότητας:</strong> Να λάβετε τα δεδομένα σε δομημένη μορφή</li>
            <li><strong>Δικαίωμα εναντίωσης:</strong> Να αντιταχθείτε στην επεξεργασία των δεδομένων σας</li>
          </ul>
        </section>

        <section>
          <h2>9. Υπηρεσίες Τρίτων</h2>
          <p>
            Ο ιστότοπός μας μπορεί να περιέχει συνδέσμους προς ιστότοπους τρίτων. Εάν κάνετε κλικ σε 
            έναν σύνδεσμο τρίτου, θα κατευθυνθείτε στον ιστότοπο αυτού του τρίτου. Σας συμβουλεύουμε 
            έντονα να εξετάσετε την Πολιτική Απορρήτου κάθε ιστότοπου που επισκέπτεστε.
          </p>
        </section>

        <section>
          <h2>10. Δεδομένα Ανηλίκων</h2>
          <p>
            Ο ιστότοπός μας δεν απευθύνεται σε άτομα κάτω των 16 ετών. Δεν συλλέγουμε εν γνώσει μας 
            προσωπικά αναγνωρίσιμες πληροφορίες από άτομα κάτω των 16 ετών. Εάν είστε γονέας ή κηδεμόνας 
            και γνωρίζετε ότι το παιδί σας μας έχει παράσχει προσωπικά δεδομένα, παρακαλούμε επικοινωνήστε μαζί μας.
          </p>
        </section>

        <section>
          <h2>11. Αλλαγές στην Πολιτική Απορρήτου</h2>
          <p>
            Μπορεί να ενημερώσουμε την Πολιτική Απορρήτου μας κατά καιρούς. Θα σας ειδοποιήσουμε για 
            τυχόν αλλαγές δημοσιεύοντας τη νέα Πολιτική Απορρήτου σε αυτήν τη σελίδα και ενημερώνοντας 
            την ημερομηνία "τελευταίας ενημέρωσης". Συνιστάται να ελέγχετε αυτήν την Πολιτική Απορρήτου 
            περιοδικά για τυχόν αλλαγές.
          </p>
        </section>

        <section>
          <h2>12. Επικοινωνία</h2>
          <p>
            Εάν έχετε οποιεσδήποτε ερωτήσεις σχετικά με αυτήν την Πολιτική Απορρήτου, μπορείτε να 
            επικοινωνήσετε μαζί μας:
          </p>
          <ul>
            <li>Μέσω email: <a href="mailto:neralen@hotmail.com">neralen@hotmail.com</a></li>
            <li>Μέσω της φόρμας επικοινωνίας στον ιστότοπό μας</li>
            <li>Ταχυδρομικά: Neralen, Αθήνα, Ελλάδα</li>
          </ul>
        </section>
      </div>
    </div>
  
    </>);
};

export default PrivacyPolicy;